/* prettier-ignore */
interface Coupons {
  [key: string]: number;
}

export const COUPONS: Coupons = {
  discount_1200_usd_off_onetime: 12,
  discount_1500_usd_off_onetime: 15,
  discount_20_usd_off_onetime: 20,
  discount_20_eur_off_onetime: 20,
  discount_21_40_usd_off_onetime: 21.4,
  discount_21_40_eur_off_onetime: 21.4,
  discount_24_usd_off_onetime: 24,
  discount_24_eur_off_onetime: 24,
  discount_30_usd_off_onetime: 30,
  discount_30_eur_off_onetime: 30,
  discount_36_usd_off_onetime: 36,
  discount_36_eur_off_onetime: 36,
  discount_45_usd_off_onetime: 45,
  discount_45_eur_off_onetime: 45,
  DISCOUNT_17_USD_OFF_ONETIME: 17,
  DISCOUNT_15_50_USD_OFF_ONETIME: 15.5,
  discount_18_usd_off_onetime: 18,
  discount_27_usd_off_onetime: 27,
  discount_22_50_usd_off_onetime: 22.5,
  discount_33_80_usd_off_onetime: 33.8,

  discount_2000_aud_off_onetime: 20,
  discount_2600_aud_off_onetime: 26,
  discount_3200_aud_off_onetime: 32,
  discount_4700_aud_off_onetime: 47,
  discount_3900_aud_off_onetime: 39,
  discount_5900_aud_off_onetime: 59,
  discount_2000_cad_off_onetime: 20,
  discount_2900_cad_off_onetime: 29,
  discount_3000_cad_off_onetime: 30,
  discount_3540_cad_off_onetime: 35.4,
  discount_5340_cad_off_onetime: 53.4,
  discount_4400_cad_off_onetime: 44,
  discount_6700_cad_off_onetime: 67,
  discount_7723_brl_off_onetime: 77.23,
  discount_5253_brl_off_onetime: 52.53,
  discount_5600_brl_off_onetime: 56,
  discount_9000_brl_off_onetime: 90,
  discount_10200_brl_off_onetime: 102,
  discount_230_mxn_off_onetime: 230,
  discount_240_mxn_off_onetime: 240,
  discount_31368_mxn_off_onetime: 313.68,
  discount_30604_mxn_off_onetime: 306.04,
  discount_21441_ars_off_onetime: 21441,
  discount_27336_ars_off_onetime: 27336,
  discount_28904_ars_off_onetime: 28904,

  discount_7000000_cop_off_onetime: 70000,
  discount_8394000_cop_off_onetime: 83940,
  discount_12594000_cop_off_onetime: 125940,
  discount_10492500_cop_off_onetime: 104925,
  discount_15742500_cop_off_onetime: 157425,
  discount_10896_gtq_off_onetime: 108.96,
  DISCOUNT_115_GTQ_OFF_ONETIME: 115,
  DISCOUNT_56_PLN_OFF_ONETIME: 56,
  DISCOUNT_54_PLN_OFF_ONETIME: 54,
  DISCOUNT_7366_PLN_OFF_ONETIME: 73.66,
  DISCOUNT_1065_DOP_OFF_ONETIME: 1065,
  DISCOUNT_1063_DOP_OFF_ONETIME: 1063,
  DISCOUNT_149_ZAR_OFF_ONETIME: 149,
  DISCOUNT_164_ZAR_OFF_ONETIME: 164,
  discount_10200000_pyg_off_onetime: 102000,
  discount_9000000_pyg_off_onetime: 90000,

  discount_4500_pen_off_once: 45,
  discount_4900_pen_off_once: 49,
  discount_5900_sar_off_once: 59,
  discount_6000_sar_off_once: 60,
  discount_5700_myr_off_once: 57,
  discount_5800_myr_off_once: 58,
  discount_6600_myr_off_once: 66,
  discount_7600_myr_off_once: 76,
  discount_1700_eur_off_once: 17,
  discount_1800_eur_off_once: 18,
  discount_4000_huf_off_once: 4000,
  discount_4001_huf_off_once: 4001,
  discount_8900_bob_off_once: 89,
  discount_9000_bob_off_once: 90,
  discount_6800_ron_off_once: 68,
  discount_6600_ron_off_once: 66,
  discount_2220_jpy_off_once: 2220,
  discount_1950_jpy_off_once: 1950,

  discount_186213_inr_off_once: 1862.13,
  discount_186212_inr_off_once: 1862.12,

  // Testing coupons
  discount_1_usd_off_onetime: 1,
  discount_1_eur_off_onetime: 1,
  discount_2_usd_off_onetime: 2,
  discount_2_eur_off_onetime: 2,
};
